import React, {useEffect} from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import { FormInputDatePicker } from "../../../ReactHookForm/FormComponents";
import DropdownSchools from "root/ReactHookForm/ui/DropdownSchools";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";
import DropdownSchoolDesiTeachers from "root/ReactHookForm/ui/DropdownSchoolDesiTeachers";

const HookSubFormSchool = ({control, register, watch, reset, formErrors, sectionName, readOnly, setValue}) =>
{
    const validateSchool = (val) =>
    {
        if (val === null)
        {
            return "Please Select a school.";
        }
    }
    const validateTeacher = (val) =>
    {
        if (val === null)
        {
            return "Please Select a designated teacher.";
        }
    }

    const [school_id] = useWatchDropdown({control, name: sectionName + '.school_id'})

    useEffect(() =>
    {
        if ( school_id !== null )
        {
            setValue ( 'school', { school_id: { value: school_id }, teacher_id: null, date_setting_started: null }) ;
        }
    }, [school_id]);

    return (
        <FieldsetContainer title='School Details' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <label className='col-form-label'>Select a school (Use the filter to narrow down the list)</label>
                    <DropdownSchools name={sectionName + '.school_id'} control={control} rules={{validate: validateSchool}}
                                                      placeHolder='Pick a school' readOnly={readOnly} isSearchable={true}/>
                    {formErrors[sectionName]?.school_id?.type === 'validate' && <ErrorDiv>Please select a school</ErrorDiv>}

                </BootstrapCol>

                <BootstrapCol width={6}>
                    <label className='col-form-label'>Select a Designated Person</label>
                    <DropdownSchoolDesiTeachers name={sectionName + '.teacher_id'} reset={reset} school_id={school_id} control={control} rules={{validate: validateTeacher}}
                                   placeHolder='Pick a teacher' readOnly={readOnly}/>
                    {formErrors[sectionName]?.carer_id?.type === 'validate' && <ErrorDiv>Please select a carer</ErrorDiv>}

                </BootstrapCol>
                <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={readOnly} label='Date Setting Started' sectionName={sectionName}
                                         name={'date_setting_started'}
                                         control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow>

        </FieldsetContainer>
    )
}


export default HookSubFormSchool;
